import React              from 'react';
// import { Observe, observable } from 'rewire-core';
// import {
//   createGrid,
//   createColumn,
//   ICell,
//   IColumn,
//   IGrid,
// }                              from 'rewire-grid';
// import {
//   IToggleMenuItem,
// }                              from 'rewire-ui';
import { DefaultEditPanelView, DefaultItemsPanelView } from './DefaultSettingsView';
import SettingsModel from './SettingsModel';
import { useCardStyle } from './UdfEditor';
// import Button                  from '@material-ui/core/Button';
// import IconButton              from '@material-ui/core/IconButton';
// import Icon                    from '@material-ui/core/Icon';
// import FilterListIcon          from '@material-ui/icons/FilterListOutlined';
// import RefreshIcon             from '@material-ui/icons/Refresh';
// import CardModeIcon            from '@material-ui/icons/ViewModule';
// import GridModeIcon            from '@material-ui/icons/ViewQuilt';
// import { makeStyles }          from '@material-ui/core/styles';
// import TuneIcon                from '@material-ui/icons/Tune';
// import MainContentToolbar      from '../main-navigation/MainContentToolbar';
// import Breadcrumbs             from '../main-navigation/Breadcrumbs';
// import { ISort }               from '../graphql/Queries';
// import InfoPanel               from '../ui/InfoPanel';
// import InfoPanelHeader         from '../ui/InfoPanelHeader';
// import InfoPanelContent        from '../ui/InfoPanelContent';
// import InfoPanelFooter         from '../ui/InfoPanelFooter';
// import Loader                  from '../ui/Loader';
// import OptionsToggleMenu       from '../ui/OptionsToggleMenu';
// import PrioritySortMenu        from '../ui/PrioritySortMenu';
// import { StyleType }           from '../utility/styles';
// import CardLayout              from './CardLayout';
// import GridLayout              from './GridLayout';
// import SettingsEditor          from './SettingsEditor';
// import SettingsModel, {
//   If,
// }                              from './SettingsModel';
// import { useCardStyle }        from './UdfEditor';

// export function hasChanges() {
//   const settings: SettingsModel | undefined = pageState.__settings;
//   if (!settings || !settings.selectedItem) return false;
//   return settings.hasChanges;
// }

// export function createGridSettings(columns: IColumn[]): [ IGrid, any] {
//   const options = {
//     clearSelectionOnBlur: false,

//     rowHeight: 36,
//     headerRowHeight: 32,
//     variableKeybinds: {
//       'Ctrl+Insert': (_evt: React.KeyboardEvent<any>, _cell: ICell) => {},
//       'Ctrl+D':      (_evt: React.KeyboardEvent<any>, _cell: ICell) => {},
//       'Ctrl+Delete': (_evt: React.KeyboardEvent<any>, _cell: ICell) => {}
//     }
//   };
//   const model = createGrid([], columns, options);

//   const selectCells = model.selectCells;

//   model.selectCells = function(cells: ICell[], cellToFocus?: ICell, handleMergedCells?: boolean, append?: boolean) {
//     const settings = pageState.__settings;
//     if (settings && cells?.length) {
//       const currentRow = model.selectedRows[0];
//       const row        = cells[0].row;
//       if (row && (!currentRow || (currentRow.id !== row.id))) {
//         settings.selectItem(row.data);
//         return;
//       }
//     }
//     selectCells.call(this, cells, cellToFocus, handleMergedCells, append);
//   };
//   return [model, selectCells];
// }

// const [settingsGridModel, oldSelectCells] = createGridSettings([
//   createColumn('code', 'Code', { type: 'text', width: '150px', align: 'left', canSort: false, readOnly: true }),
//   createColumn('name', 'Name', { type: 'text', width: '150px', align: 'left', canSort: false, readOnly: true }),
//   createColumn('tags', 'Tags', { type: 'text', width: '150px', align: 'left', canSort: false, readOnly: true, map: (v) => v && v.join(', ') }),
// ]);

// export const pageState                     = observable({ mode: 'card', __settings: undefined as (SettingsModel | undefined), loaded: false, archived: 'none', sorts: {} as ISort});
// const _optionsMenuItems: IToggleMenuItem[] = [
//   { name: 'cardLayout', title: 'View as Cards', icon: CardModeIcon, onClick: () => pageState.mode = 'card', active: () => 'card' === pageState.mode, closeOnClick: false },
//   { name: 'gridLayout', title: 'View as Grid',  icon: GridModeIcon, onClick: () => pageState.mode = 'grid', active: () => 'grid' === pageState.mode, closeOnClick: false }
// ];

// export const DisplayMenu = () => {
//   return <OptionsToggleMenu menuId='settings-display-options' classes={{}} buttonContent={<TuneIcon />} items={_optionsMenuItems} />;
// };

// const useDefaultItemsPanelViewStyles = makeStyles(_theme => ({
//   left: {
//     display: 'flex',
//     flex: '0 0 auto',
//     alignItems: 'center',
//     justifyContent: 'flex-start',
//   },
//   right: {
//     display: 'flex',
//     flex: '0 0 auto',
//     alignItems: 'center',
//     justifyContent: 'flex-end',
//     marginBottom: '7px',
//   },
//   addButton: {
//     textTransform: 'none',
//     minWidth: '0px',
//     flex: '0 0 auto',
//     marginRight: '10px',
//     '&:last-child': {
//       marginRight: '0px',
//     },
//   },
// }));

// const FilterMenu = ({settings}: {settings: SettingsModel}) => {
//   return (settings.filterMenuItems && settings.filterMenuItems.length > 0) ? <OptionsToggleMenu menuId='settings-filter' classes={{}} title='Filter By:' buttonContent={<FilterListIcon />} items={settings.filterMenuItems} /> : null;
// };

// const SortMenu = ({settings}: {settings: SettingsModel}) => {
//   return settings.sortModel ? <PrioritySortMenu menuId='settings-sort' classes={{}} model={settings.sortModel} /> : null;
// };

// export const DefaultItemsPanelView = ({ settings, refresh, classes }: { settings: SettingsModel, refresh: () => void, classes?: StyleType<typeof useCardStyle> }) => {
//   const itemsClasses = useDefaultItemsPanelViewStyles();

//   return (
//     <>
//       <MainContentToolbar>
//         <div className={itemsClasses.left}>
//           <Breadcrumbs />
//         </div>
//         <div className={itemsClasses.right}>
//           <Observe render={() =>
//             <Button className={itemsClasses.addButton} variant='contained' onClick={settings.addItem} disabled={hasChanges() || !settings.canAddItem()}>
//               <Icon className='add'>{'add'}</Icon>
//               {`Add ${settings.title}`}
//             </Button>
//           } />
//           <IconButton onClick={refresh} aria-label='Refresh'>
//             <RefreshIcon />
//           </IconButton>
//           <FilterMenu settings={settings} />
//           <SortMenu settings={settings} />
//           <DisplayMenu />
//         </div>
//       </MainContentToolbar>
//       <Observe>{() => (
//         <Loader loading={settings.isLoading}>
//           <Observe render={() => (
//             <If
//               condition={pageState.mode === 'grid'}
//               then={() => <GridLayout settings={settings} classes={classes} grid={settingsGridModel} oldSelect={oldSelectCells} />}
//               otherwise={() => <CardLayout settings={settings} classes={classes} />}
//             />
//           )} />
//         </Loader>
//       )}</Observe>
//     </>
//   );
// };

// export const DefaultEditPanelHeaderView = ({ settings }: { settings: SettingsModel, classes?: any }) => (
//   <Observe render={() => {
//     const headerOptionsTitle = `${settings.title} Options`;

//     return (
//       <InfoPanelHeader
//         title={settings.title}
//         subTitle={`${(settings.selectedItem && settings.editor?.title) || ''}`}
//         optionsMenuTitle={headerOptionsTitle}
//         optionsMenuTooltip={headerOptionsTitle}
//         optionsItems={settings.getDefaultEditPanelHeaderOptionsItems()}
//       />
//     );
//   }} />
// );

// export const DefaultEditPanelFooterView = ({ settings, classes }: { settings: SettingsModel, classes?: any }) => (
//   <Observe render={() => (
//     settings.editor && settings.selectedItem
//       ? <InfoPanelFooter isDisabled={settings.editor.isDisabled} actions={{undo: settings.editor.actions.undo, save: settings.editor.actions.save}} classes={classes} />
//       : null
//   )} />
// );

// export const DefaultEditPanelView = ({ settings, classes }: { settings: SettingsModel, classes?: any }) => {
//   const EditPanelHeaderView = settings?.EditPanelHeaderView || DefaultEditPanelHeaderView;
//   const EditPanelFooterView = settings?.EditPanelFooterView || DefaultEditPanelFooterView;

//   return (
//     <InfoPanel classes={classes}>
//       <Observe render={() => (
//         <Loader loading={settings.editor?.isLoading}>
//           < >
//             <EditPanelHeaderView settings={settings} classes={classes} />
//             <InfoPanelContent classes={classes}>
//               <SettingsEditor settings={settings} />
//             </InfoPanelContent>
//             <EditPanelFooterView settings={settings} classes={classes} />
//           </>
//         </Loader>
//       )} />
//     </InfoPanel>
//   );
// };

export default React.memo(({settings, classes}: {settings: SettingsModel, classes?: any}) => {
  const cardClasses    = useCardStyle({classes});
  const [, setRefresh] = React.useState(0);
  const EditPanelView  = settings?.EditPanelView  || DefaultEditPanelView;
  const ItemsPanelView = settings?.ItemsPanelView || DefaultItemsPanelView;

  function handleRefresh() {
    if (!settings) return;
    setRefresh((tick: number) => tick + 1);
  }

  React.useEffect(() => {
    // returned function will be called on component unmount
    return () => {
      settings.editor?.reset?.();
    };
  }, []);

  return (
    <div className={cardClasses.container}>
      <div className={cardClasses.left}>
        <ItemsPanelView settings={settings} refresh={handleRefresh} classes={cardClasses} />
      </div>
      <EditPanelView settings={settings} classes={cardClasses} />
    </div>
  );
});
